module.exports = __webpack_public_path__ + "img/mini.16847924.jpg";